import { BrowserRouter, Route, Routes } from "react-router-dom"
import Home from "../Home"
import Sluzby from "../Sluzby"
import Kontakty from "../Kontakty"
import Lokality from "../Lokality/Lokality"


function AppRoutes() {
  return (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home></Home>}></Route>
            <Route path="/sluzby" element={<Sluzby></Sluzby>}></Route>
            <Route path="/kontakt" element={<Kontakty></Kontakty>}></Route>
            <Route path="/stehovani/:lokalita" element={<Lokality></Lokality>}></Route>
        </Routes>
    </BrowserRouter>
  )
}

export default AppRoutes